<template>
  <div>
    <div class="headers"><headers></headers></div>
    <div class="msgBox flexbox">
      <div class="msgLeft">
        <navs></navs>
      </div>
      <div class="msgRight" :style="{height:mainHeight-2+'px'}">
          <div><router-view></router-view></div>
      </div>
    </div>
  </div>
</template>
<script>
import headers from "@/components/$headers.local";
import navs from "@/components/$navs.local";
export default {
  data() {
    return {
      headerHeight: "",
      mainHeight: ""
    };
  },
  mounted: function() {
    let boxHeight = document.documentElement.clientHeight;
    this.headerHeight = document.getElementsByClassName(
      "headers"
    )[0].offsetHeight;
    this.mainHeight = boxHeight - this.headerHeight;
  },
  components: {
    headers,
    navs
  }
};
</script>
<style scoped>
.msgBox {
  width: 100%;
  border-bottom: 1px solid #ccc;
  box-shadow: 0px 0px 2px #ccc;
}
.msgBox .msgLeft {
  border-right: 1px solid #dfdedf;
  box-shadow: 2px 2px 2px 2px#f3f3f3;
  box-sizing: border-box;
}
.msgBox .msgRight {
  flex: 1;
  height: 100%;
  overflow-y: auto;
  padding: 10px;
  position: relative;
  box-sizing: border-box;
}
.msgRight {
  padding-top: 13px !important;
}
</style>




// WEBPACK FOOTER //
// src/components/$index.old.vue